<template>
<div class="container">
    <div class="row mt-2">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Home'"/>
        </div>
        <div class="col-md-12 text-center">
            <h1 class="bold300 text-uppercase" style=" font-weight:500;">
                Subsidio para el Fortalecimiento del Desempeño en Materia de Seguridad Pública
                <span style="font-size:1.5rem!important">(FORTASEG)</span>
            </h1>
        </div>
  <!-- <div v-if="dataFORTASEG && dataFORTASEG.length" class="col-md-12">
    <div v-for="(item, index) in dataFORTASEG" :key="index">
      <h2>{{ item.titulo }}</h2> 
      
      <div v-for="(seccion, sectionIndex) in item.secciones" :key="sectionIndex">
        <table-section :section="seccion" :urlServe="urlServe" />
      </div>
    </div>
  </div> -->
    <div class="col-md-12">
        <select2Filtros class="mt-5" id="selectFiltroDeudaP" :data="dataAll" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" />
        <div class="w-100">
          <tabla-simple id="tabla1Filtros" class="mt-5" :titulo="textoTitulo" :datos="responseSelectComponent" />
        </div>
    </div>
    </div>
     <span  v-html="fecha_actualizacion"></span>
</div>
</template>
<script>
import mapFun from "@/common/map-fn-types.js";
import mixin from "@/mixins/mixin.js";
import RecursosMunicipios from "@/services/rendicionDeCuentas/recursosMunicipios/recursosMunicipios.js"
const recursosMunicipios_Service = new RecursosMunicipios();
import botonAtras from '../../button-atras'
import select2Filtros from '@/components/selectCompuesto2.vue';
import tablaSimple from '@/components/tablaSimple.vue';
import tableSection from '../../../components/simpleTable.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default{
    components:{botonAtras, tableSection, select2Filtros,tablaSimple},
    data(){
        return{
            dataFORTASEG: [],
            dataAll:[],
            responseSelectComponent:'',
            textoTitulo:'',
            fecha_actualizacion:''
        };
    },
    async created(){
        this.getDataFORTASEG();
        this.getProcesoAll();
        window.scrollTo(0, 0);
    },
    mixins:[mixin, DateFormat],
    methods:{
        async getDataFORTASEG(){
            try {
                const response = await recursosMunicipios_Service.getFORTASEG(mapFun.fortaseg);
                this.dataFORTASEG = response;
                let fecha_texto = this.dataFORTASEG[0].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                console.log('data', this.dataFORTASEG)
            } catch (error) {
                console.log('error vista', error.message);
            }
        },
        async getProcesoAll(){
            try {
                const response = await recursosMunicipios_Service.getFORTASEG(mapFun.fortaseg);
                this.dataAll = response.reverse();
                this.dataAll = this.dataAll.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo,
                    seccion:  e.secciones
                };
              });
              console.log('data all', this.dataAll);
            } catch (error) {
                console.log("error:", error.message);
            }
        }
    }
}
</script>
